<div class="produto-capa">
      <img [src]="image" width="100%" [alt]="nome" />
</div>      